export const FETCH_TITLE = 'stage/FETCH_TITLE';
export const FETCH_PAYMENT= 'stage/FETCH_PAYMENT';
export const FETCH_NEGOTIATION= 'stage/FETCH_NEGOTIATION';
export const FETCH_CONCESSION= 'stage/FETCH_CONCESSION';
export const FETCH_TASKS = 'stage/FETCH_TASKS';
export const ADD_TASK = 'stage/ADD_TASK';
